module.exports = __webpack_public_path__ + "img/Dra-Romelia-Lechuga.145c121a.jpg";